<!--<sub>Button</sub>-->
<div >
  <button kendoButton>{{line.variable.ui }}</button>
  {{itemValue.val}}&nbsp;
</div>
